<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>学生请假列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6" >
            <Form-item label="请假时间">
              <Row>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                    @on-change="startTimeDateChange"
                    v-model="queryParam.startTimeDate" style="width: 100%"></Date-picker>
                </Col>
                <Col :span="2" style="text-align: center">-</Col>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                    @on-change="endTimeDateChange"
                    v-model="queryParam.endTimeDate" style="width: 100%"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="操作人昵称">
                <Input placeholder="支持模糊搜索" name="adminNickname"
                  v-model="queryParam.adminNickname"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="操作人邮箱">
                <Input placeholder="支持模糊搜索" name="adminMobile"
                  v-model="queryParam.adminMobile"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生ID">
                <Input name="uid"
                  v-model="queryParam.uid"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item  label="学生手机号">
                <Input placeholder="支持模糊搜索" name="userMobile"
                  v-model="queryParam.userMobile"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生姓名">
                <Input placeholder="支持模糊搜索" name="userNickname"
                  v-model="queryParam.userNickname"></Input>
            </Form-item>
          </Col >
          <Col span="6">
            <Form-item label="请假类型">
              <Select v-model="queryParam.leaveType" @on-change="search" transfer clearable>
                <Option v-for="item in $constant.leaveType"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col span="6">
          <Form-item label="请假状态">
            <Select v-model="queryParam.status" @on-change="search" transfer clearable>
              <Option v-for="item in $constant.userLeaveStatus"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="学导">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.adminUserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
              @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                    @click="exportData">导出
            </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookUserLeaveTime/list"
      :params="queryParam" :onLoading="onLoading"></List>
    <Modal width="980" title="涉及请假课程"
      v-model="showBookLessonOpenedModal" >
      <Table class="compact" size="small" :columns="bookLessonOpenedColumn" :data="bookLessonOpenedList"></Table>
      <div slot="footer" ></div>
    </Modal>
    <Modal width="980" title="修改请假时间"
           v-model="showModifyLeaveTimeModal" >
      <Form ref="modifyTimeForm" :label-width="60" v-model="leaveTimeChangeParam" :rules="modifyLeaveTimeRule">
        <Table class="compact" size="small" :columns="bookLessonOpenedColumn" :data="bookLessonOpenedList"></Table>
        <Row><br></Row>
        <Row> 备注：若修改的时间不影响请假课程的可以直接修改，若影响到了课程的请联系技术人员修改！！！</Row>
        <Row><br></Row>
        <Form-item label="请假结束时间修改:" :label-width="120">
          <Row>
            <Col span="6" style="text-align: right">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="开始时间"
                           v-model="leaveTimeChangeParam.startLeaveTimeDate" disabled></Date-picker>
            </Col>
            <Col span="2" style="text-align: center">-</Col>
            <Col span="6" style="text-align: left">
            <Form-item prop="endTime">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="修改结束日期"
                           @on-change="newEndLeaveTimeChange"
                           v-model="leaveTimeChangeParam.endLeaveTimeDate"></Date-picker>
            </Form-item>
            </Col>
          </Row>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showModifyLeaveTimeModal=false">取消</Button>
        <Button type="primary" size="large" @click="onModifyLeaveEndTime">确认修改</Button>
      </div>
    </Modal>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
  </div>

</template>
<style scoped>
  .btn-wrap {
    display: flex;
    justify-content: end;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>
<script>
  import UserInfoModal from '../crm/UserInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  export default {
    components: {
      UserInfoModal
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      let self = this
      return {
        exportLoading: false,
        searchLoading: false,
        reload: 0,
        rankScoreSeq: 0,
        editUser: false,
        uid: null,
        queryParam: {
          uid: '',
          userMobile: '',
          userNickname: '',
          adminNickname: '',
          adminMobile: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          leaveType: null,
          status: '',
          adminUserId: ''
        },
        leaveTimeChangeParam: {
          startLeaveTimeDate: '',
          endLeaveTimeDate: '',
          startLeaveTime: 0,
          endLeaveTime: 0,
          endTime: 0,
          maxLeaveLessonTime: 0,
        },
        modifyLeaveTimeRule: {
          endTime: [
            { validator (rule, value, callback, source, options) {
              let errors = []
              if (!self.leaveTimeChangeParam.endTime) {
                errors.push('选择的时间不能为空！')
                callback(errors)
                return
              }
              if (self.leaveTimeChangeParam.endTime * 1000 < new Date().getTime()) {
                errors.push('所选时间不能小于当前时间！')
                callback(errors)
                return
              }
              if (self.leaveTimeChangeParam.endTime < self.leaveTimeChangeParam.maxLeaveLessonTime) {
                errors.push('所选时间不能小于：' + self.$moment(self.leaveTimeChangeParam.maxLeaveLessonTime, 'X').format('YYYY-MM-DD HH:mm'))
                callback(errors)
                return
              }
              if (self.leaveTimeChangeParam.endTime > self.leaveTimeChangeParam.endLeaveTime) {
                errors.push('所选时间不能大于：' + self.$moment(self.leaveTimeChangeParam.endLeaveTime, 'X').format('YYYY-MM-DD HH:mm'))
                callback(errors)
                return
              }
              callback(errors)
            } }
          ],
        },
        title: [
          {
            title: '学生ID、姓名',
            // width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              const textStyle = row.stdLeaveRule === 2 ? { fontWeight: 'bold', fontSize: '15px' } : {}
              return h('a', {on: {click: () => this.openInfoModal(row.uid)}, style: textStyle}, row.uid + '-' + row.userNickname)
            }
          },
          {
            title: '手机号码',
            align: 'center',
           // width: 130,
            // width: 130,
            key: 'userMobile',
            render: (h, params) => {
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                // eslint-disable-next-line no-undef
                h('span', {on: {click: () => this.openInfoModal(row.id)}},
                  params.row.userMobile.length === 11 ? params.row.userMobile.substring(0, 3) +
                  '****' + params.row.userMobile.substring(7) : params.row.userMobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.userMobile)
              ])
            }
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let startTime = params.row.startTime
              let endTime = params.row.endTime
              return h('span', $moment(startTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(endTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '涉及课节',
            align: 'center',
            // width: 100,
            render: (h, params) => {
              return h('div', [
                h('a', { on: { click: () => { this.onBookLessonOpened(params.row) } } }, '查看')
              ])
            }
          },
          {
            title: '操作人',
            // width: 100,
            align: 'center',
            key: 'adminNickname',
            render: (h, params) => {
              const adminNickname = params.row.adminNickname
              return h('div', adminNickname && adminNickname.trim() !== '' ? adminNickname : '学生本人')
            }
          },
          {
            title: '请假类型',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let leaveType = params.row.leaveType
              let leaveTypeEnum = $constant.getEnum($constant.leaveType, leaveType)
              return h('div', leaveTypeEnum && leaveTypeEnum.text)
            }
          },
          {
            title: '是否3小时前',
            // width: 120,
            align: 'center',
            render: (h, params) => {
              let isSixHoursAgo = params.row.isSixHoursAgo
              let isSixHoursAgoEnum = $constant.getEnum($constant.yesNoNum, isSixHoursAgo)
              return h('div', isSixHoursAgoEnum && isSixHoursAgoEnum.text)
            }
          },
          {
            title: '操作时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let updateTime = params.row.updateTime
              return h('span', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '请假原因',
            key: 'remark',
            // width: 150,
          },
          {
            title: '状态',
            // width: 80,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.userLeaveStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '操作',
            align: 'center',
            // width: 80,
            render: (h, params) => {
              let status = params.row.status
              let startTime = params.row.startTime
              let endTime = params.row.endTime
              let now = new Date().getTime()

              if (status === 1 && now / 1000 < startTime) {
                return h('div', [
                  h('a', { on: { click: () => { this.onCancel(params.row) } } }, '取消')
                ])
              }
              if (status === 1 && now / 1000 > startTime && now / 1000 < endTime) {
                return h('div', [
                  h('a', { on: { click: () => { this.onModify(params.row) } } }, '修改请假时间')
                ])
              }
            }
          }
        ],
        showBookLessonOpenedModal: false,
        showModifyLeaveTimeModal: false,
        bookLessonOpenedColumn: [
          {
            title: '学生ID、姓名',
            width: 100,
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('span', ' - '),
                h('span', row.userNickname || '')
              ])
            }
          },
          {
            title: '手机号码',
            align: 'center',
            width: 100,
            key: 'userMobile'
          },
          {
            title: '老师ID、姓名',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '学顾',
            width: 90,
            key: 'studyAdviserNickname'
          },
          {
            title: '外教运营',
            width: 90,
            key: 'adviserNickname'
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 122,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              let lsnEndTime = params.row.lsnEndTime
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '上课类型',
            align: 'center',
            width: 72,
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程名称',
            key: 'lessonTitle',
            width: 100,
          },
          {
            title: '上课时长',
            align: 'center',
            width: 72,
            key: 'courseTime'
          },
          {
            title: '上课状态',
            width: 72,
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          }
        ],
        bookLessonOpenedList: []
      }
    },
    mounted: function () {
    },
    created: function () {
      let startTime = this.queryParam.startTime
      if (startTime !== '') {
        this.queryParam.startTimeDate = this.$moment.unix(startTime).toDate()
      }
      if (startTime === '') {
        let momentDate = this.$moment().add(-6, 'M')
        momentDate.millisecond(0)
        momentDate.second(0)
        momentDate.minute(0)
        momentDate.hour(0)
        this.queryParam.startTimeDate = momentDate.toDate()
        this.queryParam.startTime = momentDate.format('X')
      }
    },
    methods: {
      closeModal (val) {
        this.uid = null
        this.editUser = val
      },
      exportData (type) {
        this.exportLoading = true
        this.$http.get('/bookUserLeaveTime/excel', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          // 检查响应数据是否有效
          if (response.data && response.data.byteLength > 0) {
            let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '请假学生列表.xlsx'
            link.click()
            this.$Message.success('导出成功')
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg || '导出失败：未获取到数据')
            this.exportLoading = false
          }
        }).catch((e) => {
          console.log(e)
          this.$Message.error('导出失败：' + (e.message || '未知错误'))
          this.exportLoading = false
        })
      },
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookUserLeaveTimeList'}})
        window.open(href, '_blank')
      },
      search () {
        this.reload = new Date().getTime()
      },
            onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      newEndLeaveTimeChange (value) {
        this.leaveTimeChangeParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onBookLessonOpened (row) {
        let self = this
        let params = {}
        params.uid = row.uid
        params.startTime = row.startTime
        params.endTime = row.endTime

        self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
          self.showBookLessonOpenedModal = true
          self.bookLessonOpenedList = res.data
        })
      },
      onModify (row) {
        let self = this
        self.leaveTimeChangeParam.id = row.id
        self.leaveTimeChangeParam.startLeaveTime = row.startTime
        self.leaveTimeChangeParam.endLeaveTime = row.endTime
        self.leaveTimeChangeParam.startLeaveTimeDate = self.$moment(row.startTime, 'X').format('YYYY-MM-DD HH:mm')
        self.leaveTimeChangeParam.endLeaveTimeDate = self.$moment(row.endTime, 'X').format('YYYY-MM-DD HH:mm')

        let params = {}
        params.uid = row.uid
        params.startTime = row.startTime
        params.endTime = row.endTime
        self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
          self.showModifyLeaveTimeModal = true
          self.bookLessonOpenedList = res.data
          console.log('A:' + JSON.stringify(self.bookLessonOpenedList))
          for (var j = 0; self.bookLessonOpenedList[j] != null; j++) {
            console.log('B:' + JSON.stringify(self.bookLessonOpenedList[j]))
            console.log('item.lsnEndTime:' + self.bookLessonOpenedList[j].lsnEndTime)
            if (self.leaveTimeChangeParam.maxLeaveLessonTime < self.bookLessonOpenedList[j].lsnEndTime) {
              self.leaveTimeChangeParam.maxLeaveLessonTime = self.bookLessonOpenedList[j].lsnEndTime
            }
          }
        })
      },
      onCancel (row) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '是否 <b>取消</b> 此次请假？',
          width: 300,
          okText: '确定取消',
          loading: true,
          onOk: () => {
            self.$http.post('/bookUserLeaveTime/cancel', {id: row.id}).then(function (res) {
              if (res) {
                self.$Message.success('取消成功!')
                self.search()
              }
              self.$Modal.remove()
            })
          }
        })
      },
      onModifyLeaveEndTime () {
        let self = this
        self.$refs.modifyTimeForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }
          self.$Modal.confirm({
            title: '提示',
            content: '是否确认修改请假时间？',
            width: 300,
            okText: '确定修改',
            onOk: () => {
              self.$http.post('/bookUserLeaveTime/modifyEndTime', self.leaveTimeChangeParam).then(function (res) {
                if (res && res.data > 0) {
                  self.$Message.success('修改成功!')
                  self.showModifyLeaveTimeModal = false
                  self.search()
                } else {
                  self.$Message.error(res.message)
                }
                self.$Modal.remove()
              })
            }
          })
        })
      },
    }
  }

</script>



// WEBPACK FOOTER //
// BookUserLeaveTimeList.vue?690cb18a